import { Record, List, Map } from 'immutable'
import {
  GET_INSPECTION_BUDGET_BY_ID,
  GET_INSPECTION_BUDGETS,
  GET_INSPECTION_TRADESMEN,
  GET_COMPARTMENTS,
  GET_INSPECTION_BUDGET_RESOLUTION_MATERIAL_UNIDS,
  UPDATE_INSPECTION_BUDGET,
} from './actions'
import { createReducer } from '_utils/redux'

const INITIAL_STATE = new Record({
  results: List(),
  count: 0,
  tradesmen: null,
  compartments: null,
  materialUnids: null,
  currentBudget: Map(),
})()

export const inspectionBudget = createReducer(INITIAL_STATE, {
  [GET_INSPECTION_BUDGETS.FULFILLED]: (state, { payload }) => {
    return state.set('results', payload.results).set('count', payload.count)
  },
  [GET_INSPECTION_BUDGET_BY_ID.FULFILLED]: (state, { payload }) => {
    return state.set('currentBudget', payload)
  },
  [GET_INSPECTION_TRADESMEN.FULFILLED]: (state, { payload }) => {
    return state.set('tradesmen', payload)
  },
  [GET_COMPARTMENTS.FULFILLED]: (state, { payload }) => {
    return state.set('compartments', payload)
  },
  [GET_INSPECTION_BUDGET_RESOLUTION_MATERIAL_UNIDS.FULFILLED]: (state, { payload }) => {
    return state.set('materialUnids', payload)
  },
  [UPDATE_INSPECTION_BUDGET.FULFILLED]: (state, { payload }) => {
    return state.set('currentBudget', payload)
  },
})
